<template>
  <div>

    <!-- validate token -->
    <transition name="slide-fade" enter-active-class="animated flipInY" leave-active-class="animated fadeOut" mode="out-in">
      <div id="verify-token-card" v-if="state == 1" key="loader">
        <h3>Validating token</h3>
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </div>

      <div class="sign-in-card" v-if="state == 2" key="form">

        <div class="card-header">
          <h3>Success</h3>
        </div>

        <div class="card-body">

          <div>Account unlocked. You can now log in again.</div>

          <v-btn 
          class="white-text crx-gradient-purple font-weight-bold"
          large
          rounded
          @click="redirectToSignin"
          block>
            Log in
          </v-btn>
        </div>
      </div>

  <!-- token not found -->
    <v-card 
    v-if="state == -1" 
    key="tokenExpired"
    class="pa-1">
      <v-layout align-center class="pa-4">
        <v-icon x-large color="blue-grey lighten-2">error_outline</v-icon>
        <h3 class="ml-2" style="color: #90A4AE;">The reset token has expired or is invalid.</h3>
      </v-layout>
      <div class="c-hr"></div>
      <div>
        <router-link to="/auth/sign-in" style="text-decoration: none;">
          <v-btn flat color="green">
            <v-icon>mdi-arrow-left</v-icon>Back
          </v-btn>
        </router-link>
      </div>
    </v-card>
  </transition>

  </div>
</template>

<script>
export default {
  data () {
    return {
      state: 1,
      loading: false,
    }
  },
  computed: {
  },
  methods: {
    verifyToken () {
      this.$axios.post('users/blacklist/verify-token',
        {token: this.$route.query.token},
        {headers: {'Content-Type': 'application/json'}})
        .then(
          (response) => {
            console.log(response)
            this.username = response.data.username
            this.state = 2
          })
        .catch(
          (error) => {
            console.log(error)
            this.state = -1
          })
        // */
    },
    redirectToSignin () {
      this.$router.push('/auth/sign-in')
    }
  },
  created () {
    this.verifyToken()
  }
}
</script>

<style scoped>
.card-header {
  border-bottom: 1px solid #EEE;
  padding: 10px;
}

.card-body {
  padding: 20px;
}

.sign-in-card {
  display: inline-block;
  background: white;
  width: 300px;
  border-radius: 4px;
  box-shadow: 2px 2px 10px rgba(0,0,0,0.4);
}

.white-text {
  color: white;
  text-transform: none;
}

h2 {
  text-align: center;
  color: white;
}

a {
  margin-left: auto;
  text-decoration: none;
  display:block;
  color: #BBB;
}

a:active {
  color: purple;
}

a:hover {
  color: purple;
  text-decoration: underline;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

#verify-token-card {
  display: inline-block;
  background: white;
  border-radius: 4px;
  box-shadow: 2px 2px 10px rgba(0,0,0,0.4);
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #90A4AE;
}

#token-expired-card {
  display: inline-block;
  background: white;
  border-radius: 4px;
  box-shadow: 2px 2px 10px rgba(0,0,0,0.4);
  padding: 30px;
  display: flex;
  align-items: center;
  color: #90A4AE;
}
.error-text {
  color: #AD1457;
  text-align: center;
}

</style>
